import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { Spinner } from '@interstate/components/Spinner';
import Vehicle from './Vehicle/Vehicle.interstate';
import ModalAuditLog from './Modal/ModalAuditLog.interstate';
import AuditLogLayout from './AuditLogLayout';
import { LoadingIndicatorWrapper, BaseHeaderTitle, StyledVehicleWrapper, StyledHeaderWrapper } from './Audit.style';
import { loadingDesc, messages } from '../types/AuditLog';
import MessageBanner from './MessageBanner/MessageBanner.interstate';
import { useAuditLog } from '../hooks/useAuditLog';

/**
 * AuditLog component displays deal history with version tracking and change logs.
 * Self-contained component that manages its own state via useAuditLog hook.
 */
const AuditLog = () => {
    const {
        auditLogSlideout,
        bannerType,
        isLoadingDealVersion,
        isPrintError,
        isLoadingChangeLog,
        dealVersions,
        dealChangeLog,
        handleSetSlideoutProps
    } = useAuditLog();
    const theme = useInterstateTheme();

    return (
        <Box>
            <StyledHeaderWrapper>
                <BaseHeaderTitle data-testid="audit-log-header-title">Deal History</BaseHeaderTitle>
            </StyledHeaderWrapper>
            {bannerType && <MessageBanner {...messages[bannerType]} />}
            {isPrintError && <MessageBanner {...messages['error']} />}
            <StyledVehicleWrapper theme={theme}>
                <Vehicle />
            </StyledVehicleWrapper>
            {(isLoadingDealVersion || isLoadingChangeLog) && (
                <LoadingIndicatorWrapper>
                    <Spinner />
                    <Typography variant="h4">{loadingDesc}</Typography>
                </LoadingIndicatorWrapper>
            )}
            {!(isLoadingDealVersion || isLoadingChangeLog) && (
                <AuditLogLayout
                    dealVersions={dealVersions}
                    dealChangeLog={dealChangeLog}
                    handleSetSlideoutProps={handleSetSlideoutProps}
                />
            )}

            {/* istanbul ignore next */ auditLogSlideout !== null && <ModalAuditLog record={auditLogSlideout} />}
        </Box>
    );
};

export default AuditLog;
